import DropzoneController from "../dropzone_controller";

export default class extends DropzoneController {
  static targets = ["previewTemplate", ...DropzoneController.targets];
  static values = {
    ...DropzoneController.values,
    uploadUrl: { type: String, default: "/tax-center/uploads" },
    acceptedFiles: { type: String, default: ".pdf,.png" },
    maxFilesize: { type: Number, default: 50 },
    maxFiles: { type: Number, default: 10 },
  };

  // Read preview template from a hidden DOM element instead of embedding HTML in JS
  get previewTemplate() {
    if (this.hasPreviewTemplateTarget) {
      return this.previewTemplateTarget.innerHTML;
    }
    return null;
  }

  fileAdded(file) {
    super.fileAdded(file);
    // Show progress spinner
    const progress = file.previewElement.querySelector(".dz-progress");
    if (progress) progress.style.display = "block";
  }

  fileUploaded(file, response) {
    super.fileUploaded(file, response);

    if (response.success) {
      // Hide spinner, show checkmark
      const progress = file.previewElement.querySelector(".dz-progress");
      if (progress) progress.style.display = "none";

      // Dispatch event so the marketing modal controller can transition states
      this.dispatch("uploaded", {
        detail: { taskId: response.task_id, name: response.name, size: response.size },
      });
    }
  }
}
